import getNoticeCode from './helpers/getNoticeCode'

export default () => {
    return {
        noticeCode: getNoticeCode()
    }
}
